import React, { Component } from 'react'
import { Grid, Row, Col } from 'react-bootstrap'
import { object } from 'prop-types'

import ABTestRound from './ABTestRound'
import ABTestNewRound from './ABTestNewRound'

class ABTest extends Component {
  render () {
    let { video } = this.props
    return (
      <Grid>
        <Row>
          <Col md={12}>
            <div className='page-header clearfix'>
              <h2 className='pull-left'>
                Teste A/B - {video.title}
              </h2>
            </div>
          </Col>
        </Row>
        {(!video.thumbnails || (video.thumbnails && video.thumbnails.length === 0)) &&
          <h4 className='text-center'>Esse vídeo não possui thumbnails cadastrados. Cadastre pelo menos 2 thumbnails e tente novamente.</h4>
        }
        {!video.thumbnail_abtest && (video.thumbnails && video.thumbnails.length > 0) &&
          <ABTestNewRound thumbnails={video.thumbnails} video={video} />
        }
        {video.thumbnail_abtest && video.thumbnail_abtest.rounds && video.thumbnail_abtest.rounds.length > 0 && video.thumbnail_abtest.rounds.map((round, index) => (
          <ABTestRound key={index} thumbnails={video.thumbnails} round={round} index={index} />
        ))}
      </Grid>
    )
  }
}

ABTest.propTypes = {
  video: object
}

export default ABTest



// WEBPACK FOOTER //
// ./src/components/ABTest.js